var lists_default = {
  "fontElementMap": "f07WY",
  "orderedlist": "cz3gJ",
  "bulletedlist": "bBxGW",
  "listItem": "_3CGqW"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
